import React from 'react';

const whoShouldApplyItems = [
    {
        text: "Small & Medium Business Owners looking to scale operations.",
        imgSrc: "/assets/img/wsaIcons (5).png",
        imgAlt: "Business Owners Icon",
        imgHeight: 28,
        imgWidth: 28,
    },
    {
        text: "Entrepreneurs seeking working capital for daily business needs.",
        imgSrc: "/assets/img/wsaIcons (3).png",
        imgAlt: "Entrepreneurs Icon",
        imgHeight: 31,
        imgWidth: 31,
    },
    {
        text: "Retailers, Manufacturers, & Service Providers needing funds for expansion.",
        imgSrc: "/assets/img/wsaIcons (4).png",
        imgAlt: "Retailers Icon",
        imgHeight: 31,
        imgWidth: 44,
    },
    {
        text: "Traders & Wholesalers looking to stock up on inventory.",
        imgSrc: "/assets/img/wsaIcons (2).png",
        imgAlt: "Wholesalers Icon",
        imgHeight: 32,
        imgWidth: 32,
    },
    {
        text: "Self-Employed Professionals requiring financial support for business growth.",
        imgSrc: "/assets/img/wsaIcons (1).png",
        imgAlt: "Self-Employed Icon",
        imgHeight: 28,
        imgWidth: 37,
    },
];

const BusinessLoanCards = () => {
    return (
        <div className=" w-[93vw] sm:w-auto max-w-6xl  mx-auto p-2 lg:p-8 mt-5">
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
                {/* Who Should Apply Card */}
                <div className="bg-white rounded-3xl shadow-lg lg:pl-[20px] lg:py-[65px] p-6 flex-1 box-border">
                    <h2 className="text-2xl  sm:text-left sm:pl-8 lg:text-4xl font-bomstad-semibold text-gray-800 mb-8">
                        Who Should Apply?
                    </h2>


                    <div className="space-y-6">
                        {whoShouldApplyItems.map((item, index) => (
                            <div key={index} className="flex items-center justify-around w-[100%] sm:w-[90%]">
                                <div className=" p-3 rounded-lg shrink-0">
                                    <img
                                        src={item.imgSrc}
                                        alt={item.imgAlt}
                                        height={item.imgHeight}
                                        width={item.imgWidth}
                                        className="object-contain"
                                    />
                                </div>
                                <p className="text-gray-700 leading-snug text-sm lg:max-w-[75%] lg:text-base font-atkinson">
                                    {item.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* How a Business Loan Can Help You Card */}
                <div className="bg-black text-white rounded-3xl shadow-lg flex-1 box-border overflow-hidden">
                    {/* Full-width example bar */}
                    <div className="bg-green-400 text-black mt-5 px-6 lg:px-[50px] py-1 font-pp-hatton">
                        <span className="text-4xl italic">Example</span>
                    </div>

                    {/* Content area with inner padding */}
                    <div className="px-6 lg:px-[70px] py-8 lg:py-[30px]">
                        <h2 className="text-2xl lg:text-4xl mb-6 font-bomstad-semibold">
                            How a Business Loan Can Help You
                        </h2>

                        <p className="text-gray-300 mb-6 font-atkinson leading-[1.6] text-sm lg:text-base">
                            Imagine you run a retail business and need ₹10,00,000 for expansion. Here's a simple breakdown of how a business loan can work for you. This loan can help you grow without putting financial pressure upfront.
                        </p>

                        <ul className="mb-6 mt-3 text-sm font-atkinson leading-relaxed lg:text-base space-y-1">
                            <li className="flex items-start gap-2">
                                <span className="text-white">•</span>
                                <span>Loan Amount: ₹10,00,000</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-white">•</span>
                                <span>Annual Interest Rate: 14%</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-white">•</span>
                                <span>Loan Tenure: 3 years</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-white">•</span>
                                <span>Fixed EMI: ₹34,220 per month</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-white">•</span>
                                <span>Total Repayment Amount: ₹12,31,920 (including interest)</span>
                            </li>
                        </ul>

                        <p className="text-gray-300 font-atkinson leading-relaxed text-sm lg:text-base">
                            With structured financing, you can scale up operations smoothly, boost revenue, and repay the loan without financial stress.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessLoanCards;
